import { StatusChip } from "@/components/shared/status-chip";

/** NymblFinance holds unclosed forward periods in the same table as actuals --
 *  368 of 3,368 rows, running to April 2027. An unlabelled forecast reads as a
 *  fact, so an unknown state is labelled too. */
export function ForecastBadge({ isClosed }: { isClosed: boolean | null }) {
  if (isClosed === true) return null;
  return (
    <StatusChip tone="info" title="This period is not closed; these figures are a forecast">
      Forecast
    </StatusChip>
  );
}
